module.exports = __webpack_public_path__ + "img/01.a815ec14.png";